import { create } from 'zustand'

type OpenMembershipDialogOptions = {
  preferredPlanCode?: string | null
  preferredCreditPackCode?: string | null
  refreshOrder?: boolean
  surface?: 'marketing' | 'workspace'
}

type MembershipDialogState = {
  open: boolean
  preferredPlanCode: string | null
  preferredCreditPackCode: string | null
  refreshOrder: boolean
  surface: 'marketing' | 'workspace'
  openDialog: (options?: OpenMembershipDialogOptions) => void
  closeDialog: () => void
}

export const useMembershipDialogStore = create<MembershipDialogState>((set) => ({
  open: false,
  preferredPlanCode: null,
  preferredCreditPackCode: null,
  refreshOrder: false,
  openDialog: (options) =>
    set({
      open: true,
      preferredPlanCode: options?.preferredPlanCode ?? null,
      preferredCreditPackCode: options?.preferredCreditPackCode ?? null,
      refreshOrder: Boolean(options?.refreshOrder),
      surface: options?.surface ?? 'marketing',
    }),
  closeDialog: () => set({ open: false, preferredPlanCode: null, preferredCreditPackCode: null, refreshOrder: false, surface: 'marketing' }),
}))
